import { render } from "./BugTableEntry.vue?vue&type=template&id=73d64e54"
import script from "./BugTableEntry.vue?vue&type=script&lang=js"
export * from "./BugTableEntry.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__